export default [
  {
    name: 'home',
    path: '/',
  },
  {
    name: 'demo',
    path: '/public/demo/',
    component: () => import('./demo'),
  },
  {
    name: 'quitPublicApp',
    path: '/quit/',
    redirect: async () => {
      window.location.assign('/');
      return new Promise(() => null);
    },
  },
  {
    name: 'sharedItem',
    path: '/shared/item/:uuid/',
    component: () => import('./shared-item'),
    children: [
      {
        name: 'unsubscribe',
        path: 'unsubscribe/',
        component: () => import('./shared-item'),
      },
    ],
  },
  {
    name: 'sharedDocumentStatus',
    path: '/shared/document/:status/',
    component: () => import('./shared-document/status'),
  },
  {
    name: 'requestAccess',
    path: '/shared/request/:token/',
    component: () => import('./request-access'),
  },
  // {
  //   name: 'petition',
  //   path: '/public/petition/',
  //   component: () => import('./petition/'),
  // },
  {
    name: 'flow',
    path: '/public/flow/:flowId/',
    redirect: (store, state) => {
      return {
        ...state,
        name: 'flow.page',
        params: {
          ...state.params,
          path: 'root',
        },
      };
    },
    children: [
      {
        name: 'page',
        path: '*path',
        component: () => import('src/components/flows/flow'),
      },
    ],
  },
  {
    name: 'splitter',
    path: '/public/splitter/',
    redirect: async () => {
      window.location.assign('/');
      return new Promise(() => null);
    },
  },
  {
    name: 'forms',
    path: '/public/forms/:urlPath',
    component: () => import('./forms'),
  },
  {
    name: 'pp',
    path: '/public/pp/:uuid/',
    component: () => import('./pp'),
    children: [
      {
        name: 'submitOfferError',
        path: 'submit-offer-error/?error',
        component: () => import('./pp/submit-offer-error'),
      },
    ],
  },
  {
    name: 'docusign-placeholder',
    path: '/public/load-docusign',
    component: () => import('./integrations/docusign-placeholder'),
    titleFunction: () => {
      return 'Syncing to DocuSign®';
    },
  },
  {
    name: 'redirect',
    path: '/public/redirect/?url&auto',
    component: () => import('./redirect'),
  },
];
